import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout'; // Isse import karo
import HomeScreen from './screens/HomeScreen';
import SelectProduct from './screens/SelectProduct'; 
import DeviceDetails from './screens/DeviceDetails';
import Condition from './screens/Condition';
import PhysicalDefects from './screens/PhysicalDefects';
import Problems from './screens/Problems';
import DeviceAge from './screens/DeviceAge';
import Accessories from './screens/Accessories';
import Price from './screens/Price';
import Address from './screens/Address';
import Slot from './screens/Slot';
import Payment from './screens/Payment';
import ThankYou from './screens/ThankYou';
import Profile from './screens/Profile';
import Orders from './screens/Orders';
import OrderDetails from './screens/OrderDetails';
import SelectBrand from './screens/SelectBrand';
import About from './screens/About';
import ScrollToTop from "./ScrollToTop";
import PrivacyPolicy from './screens/PrivacyPolicy';
function App() {
  return (
    <Router>
      <ScrollToTop />
      {/* Layout yahan aayega, taaki ye Header aur Footer ko pakad sake */}
      <Layout>
        <Routes>
          {/* Ab jo bhi Route iske andar hoga, usme Header/Footer dikhega */}
          <Route path="/" element={<HomeScreen />} />
          {/* ✅ Dynamic Route for Products */}
          <Route path="/sell/products/:brandId" element={<SelectProduct />} />
          {/* Next screen for device details */}
          <Route path="/sell/device/:deviceId" element={<DeviceDetails />} />
          <Route path="/sell/condition/:deviceId/:variantId" element={<Condition />} />
          <Route path="/sell/defects/:deviceId/:variantId" element={<PhysicalDefects />} />
          <Route path="/sell/problems/:deviceId/:variantId" element={<Problems />} />
          <Route path="/sell/age/:deviceId/:variantId" element={<DeviceAge />} />
          <Route path="/sell/accessories/:deviceId/:variantId" element={<Accessories />} />
          <Route path="/sell/price/:deviceId/:variantId" element={<Price />} />
          <Route path="/sell/address" element={<Address />} />
          <Route path="/sell/slot" element={<Slot />} />
          <Route path="/sell/payment" element={<Payment />} />
          <Route path="/sell/thankyou" element={<ThankYou />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/:orderId" element={<OrderDetails />} />
          <Route path="/sell/brands" element={<SelectBrand />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* Future mein koi bhi naya page banaoge toh wo yahan aayega */}
          {/* <Route path="/product" element={<ProductList />} /> */}
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;